export const DATE_STRING_FORMAT = 'DD-MM-YYYY';

export const MONTHS_IN_YEAR = 12;
